// extracted by mini-css-extract-plugin
export var actionButton = "_9g-1";
export var actionButtons = "_9g-2";
export var actions = "_9g-0";
export var aiUnread = "_9g-10";
export var alignCenter = "_9g-h";
export var backWrapper = "_9g-3";
export var cellContainer = "_9g-4";
export var checkboxContainer = "_9g-5";
export var contentContainer = "_9g-6";
export var contentHeader = "_9g-8";
export var conversationsTableWrapper = "_9g-s";
export var draftReplyBadgeContainer = "_9g-m";
export var dropdownItem = "_9g-b";
export var dropdownItemsContainer = "_9g-a";
export var dropdownTitle = "_9g-c";
export var errorIcon = "_9g-7";
export var filter = "_9g-d";
export var gray = "_9g-i";
export var headerActionButtons = "_9g-e";
export var headerCheckboxContainer = "_9g-f";
export var icon = "_9g-j";
export var menuContainer = "_9g-k";
export var noMoreTicketsIcon = "_9g-12";
export var noMoreTicketsSubText = "_9g-13";
export var oneLine = "_9g-l";
export var optionsButton = "_9g-n";
export var plus = "_9g-o";
export var portalButtonsWrapper = "_9g-g";
export var red = "_9g-p";
export var scrolledTop = "_9g-9";
export var search = "_9g-q";
export var selectedConversationsCount = "_9g-r";
export var spinner = "_9g-t";
export var strong = "_9g-u";
export var summaryCell = "_9g-v";
export var tableContainer = "_9g-11";
export var tagContainer = "_9g-w";
export var threeDots = "_9g-x";
export var twoLines = "_9g-y";
export var unread = "_9g-z";